import React, { useContext, useMemo, useEffect, useState } from "react";
import _ from "lodash";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { TextField } from "@material-ui/core";
import { MEDIA_SEARCH, ASSET_TYPE } from "../../constants/MediaSearch";
import { MediaRequestContext } from "../../context/MediaRequestContext";
import CircularProgress from '@material-ui/core/CircularProgress';
import "../../styles/media-search.scss";

const MediaSearchBar = () => {
  const {
    options,
    _setOptions,
    fetchSearchOptions,
    recordType,
    _setSelectedOption,
    suggestString,
    _setSuggestString,
    _setValidAssets,
    selectedOption,
    noOptionsFound,
  } = useContext(MediaRequestContext);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if(!_.isEmpty(selectedOption)) {
      _setSuggestString( _.get(selectedOption, "payload.title", ""));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOption]);
  
  const brandNames = sessionStorage.getItem(MEDIA_SEARCH.storageKey)
    ? JSON.parse(sessionStorage.getItem(MEDIA_SEARCH.storageKey))
    : null;

  const searchOptions = useMemo(
    () => _.debounce(fetchSearchOptions, MEDIA_SEARCH.throttleTime),
    // eslint-disable-next-line
    []
  );

  useEffect(() => {
    return () => {
      searchOptions.cancel();
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (noOptionsFound) {
      setLoading(false);
    }
    // eslint-disable-next-line
  }, [noOptionsFound]);

  const renderAutocompleteOption = (option) => {
    setLoading(false);
    const {
      brandAbbr,
      recordType,
      showAbbr,
      propertyId,
      scrid,
      title,
      titleType,
    } = option.payload;
    const releaseDate = option?.payload?.releaseDate ?? "No Release Date";
    let brandName = brandNames ? brandNames[brandAbbr] : "";
    let abbrOrId;
    if (recordType === ASSET_TYPE.MOVIE) {
      abbrOrId = showAbbr ? `(${showAbbr})` : `(${scrid})`;
    } else if (recordType === ASSET_TYPE.SEASON && scrid) {
      abbrOrId = `(${scrid})`;
    } else if (recordType === ASSET_TYPE.EPISODE) {
      abbrOrId = showAbbr ? `(${showAbbr})` : "";
    } else if (recordType === ASSET_TYPE.PROMO) {
      abbrOrId = scrid ? `(${scrid})` : "";
    } else if(recordType === ASSET_TYPE.DMI_TITLE) {
      abbrOrId = scrid ? `(${scrid})` : "";
      abbrOrId = propertyId ? `${abbrOrId} (${propertyId})` : abbrOrId;
      brandName = brandAbbr;
    } else {
      abbrOrId = "";
    }
    return (
      <div className="listOptions">
        <div title={`${title} ${abbrOrId}`} className="titleWrapper">
          <span className="optionTitle">{title}</span>
          <span className="abbrOrId">{abbrOrId}</span>
          {titleType === "Working Title" && (
            <span className="workingTitle">(Working Title)</span>
          )}
        </div>
        {recordType === ASSET_TYPE.DMI_TITLE ? null : (
          <div title={releaseDate} className="releaseDate">
            {releaseDate}
          </div>
        )}
        <div title={brandName} className="brandName">
          {brandName}
        </div>
        {recordType === ASSET_TYPE.DMI_TITLE ? (
          <div title={titleType} className="dmiRecordType">
            {titleType}
          </div>
        ) : null}
      </div>
    );
  };

  return (
    <Autocomplete
      freeSolo
      inputValue={suggestString}
      classes={{
        inputRoot: "formAutoCompleteEmailRootMedia",
        option: "formAutoCompleteOption",
        input: "formAutoCompleteEmailInputMedia",
        popper: "formAutoCompleteEmailPopper",
        focused: "formAutoCompleteEmailFocused",
      }}
      open={open}
      onOpen={() => {
        setOpen(true);
      }}
      onClose={() => {
        setOpen(false);
      }}
      loading={loading}
      loadingText="Loading options.."
      disablePortal={true}
      id="media-search-bar"
      filterOptions={(x) => x}
      options={
        suggestString.length > MEDIA_SEARCH.minimumKeyStroke ? options : []
      }
      renderOption={(option) => renderAutocompleteOption(option)}
      getOptionLabel={(option) => option?.payload?.title }
      onChange={(e, value) => {
        _setValidAssets({});
        if (value) _setSelectedOption(value);
      }}
      onInputChange={(e, value, reason) => {
        _setSuggestString(value);
        if (
          value &&
          value.length > MEDIA_SEARCH.minimumKeyStroke &&
          reason === "input"
        ) {
          setOpen(true);
          setLoading(true);
          searchOptions(value, recordType);
        } else {
          setLoading(false);
          _setOptions([]);
        }
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          placeholder={MEDIA_SEARCH.placeholder}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? <CircularProgress color="inherit" size={16} /> : null}
                {params.InputProps?.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
};

export default MediaSearchBar;
